// extracted by mini-css-extract-plugin
module.exports = {"bodyRedirect":"bodyRedirect___2oD-u","wrapperButtons":"wrapperButtons___2WEbD"};